<template>
    <div class="mvt-popsignin" v-if="!close">
        <div class="grid xs-grid-cols-1 bg-default inline panel corner gap-3">
            <a @click="closePop" class="icon-times f3 mvt-popsignin-close" role="button"></a>
            <mvtAuthenticate  :options="{trigger:$options.name, type:'mvtLogin'}"/>
        </div>
    </div>
</template>
<script src="./mvt-popsignin.js"></script>

<style lang="scss">
@use "./mvt-popsignin.scss" as *;
</style>